var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeforeMonAzul(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_486",
    "data-name": "Grupo 486",
    transform: "translate(-1478 -1431)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_452",
    "data-name": "Grupo 452"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_82",
    "data-name": "Rect\\xE1ngulo 82",
    width: 16,
    height: 16,
    transform: "translate(1494 1431) rotate(90)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "chevron_right_FILL0_wght300_GRAD0_opsz40",
    d: "M354.007-691.856l-3.71-3.715a.492.492,0,0,1-.157-.375.517.517,0,0,1,.166-.378.525.525,0,0,1,.384-.163.525.525,0,0,1,.384.163l4,4a.7.7,0,0,1,.154.219.637.637,0,0,1,.048.251.643.643,0,0,1-.048.248.685.685,0,0,1-.154.222l-4.007,4.007a.51.51,0,0,1-.375.155.526.526,0,0,1-.383-.164.525.525,0,0,1-.163-.384.525.525,0,0,1,.163-.384Z",
    transform: "translate(1839.037 746.645) rotate(180)",
    fill: "#00bdd9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeforeMonAzul);
export default __webpack_public_path__ + "static/media/before-mon-azul.b459593458882401df0c72aaea00766e.svg";
export { ForwardRef as ReactComponent };